import type { FunctionComponent, PropsWithChildren } from 'react';

import { FeedbackDialogContextProvider } from './FeedbackDialogContext';
import { FeedbackToaster } from './FeedbackToaster';
import { SkillFeedbackModalContextProvider } from './ModalContext';
import { SkillFeedbackModal } from './SkillFeedbackModal';

export const SkillFeedbackModalProvider: FunctionComponent<
    PropsWithChildren & { readonly isWithFloatingActionButton: boolean }
> = ({ children }) => {
    return (
        <>
            <FeedbackDialogContextProvider>
                {children}
                <SkillFeedbackModal />
            </FeedbackDialogContextProvider>
            <FeedbackToaster />
        </>
    );
};

export const SkillFeedbackModalRoot: FunctionComponent<
    PropsWithChildren & { readonly isWithFloatingActionButton?: boolean }
> = ({ children, isWithFloatingActionButton = false }) => {
    return (
        <SkillFeedbackModalContextProvider>
            <SkillFeedbackModalProvider isWithFloatingActionButton={isWithFloatingActionButton}>
                {children}
            </SkillFeedbackModalProvider>
        </SkillFeedbackModalContextProvider>
    );
};
